"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'StatementDetailDialog',
  data: function data() {
    return {
      visible: false,
      detailLoading: false,
      detail: {},
      summaryFromList: this.getDefaultSummaryFromList()
    };
  },
  computed: {
    merchantFileList: function merchantFileList() {
      return this.parseMerchantFiles(this.detail.merchantFile);
    }
  },
  methods: {
    open: function open(row) {
      this.visible = true;
      this.detail = row || {};
      this.summaryFromList = this.getSummaryFromList(row || {});
      this.getDetail();
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    handleClosed: function handleClosed() {
      this.detail = {};
      this.summaryFromList = this.getDefaultSummaryFromList();
    },
    getDetail: function getDetail() {
      var _this = this;
      if (!this.detail.id) return;
      this.detailLoading = true;
      statementApi.statementDetailApi(this.detail.id).then(function (data) {
        _this.detail = _objectSpread(_objectSpread({}, _this.detail), data || {});
      }).catch(function () {}).finally(function () {
        _this.detailLoading = false;
      });
    },
    getDefaultSummaryFromList: function getDefaultSummaryFromList() {
      return {
        orderAmount: 0,
        settlementAmount: 0,
        orderCount: 0,
        actualAmount: 0,
        freightAmount: 0,
        packingFeeAmount: 0,
        actualSettlementFreightAmount: 0,
        actualSettlementPackingFeeAmount: 0
      };
    },
    getSummaryFromList: function getSummaryFromList(row) {
      return {
        orderAmount: row.orderAmount,
        settlementAmount: row.settlementAmount,
        orderCount: row.orderCount,
        actualAmount: row.actualAmount,
        freightAmount: row.freightAmount,
        packingFeeAmount: row.packingFeeAmount,
        actualSettlementFreightAmount: row.actualSettlementFreightAmount,
        actualSettlementPackingFeeAmount: row.actualSettlementPackingFeeAmount
      };
    },
    formatAmount: function formatAmount(val) {
      return val != null ? Number(val).toFixed(2) : '0.00';
    },
    formatActualSettlementAmount: function formatActualSettlementAmount(row) {
      var actualAmount = Number(row.actualAmount || 0);
      var actualSettlementFreightAmount = Number(row.actualSettlementFreightAmount || 0);
      var actualSettlementPackingFeeAmount = Number(row.actualSettlementPackingFeeAmount || 0);
      return this.formatAmount(actualAmount + actualSettlementFreightAmount + actualSettlementPackingFeeAmount);
    },
    hasAmount: function hasAmount(val) {
      if (val === '' || val === null || val === undefined) return false;
      var amount = Number(val);
      return !isNaN(amount) && amount !== 0;
    },
    reconciliationStatusText: function reconciliationStatusText(status) {
      var map = {
        0: '未核对',
        1: '已核对'
      };
      return map[status] || '-';
    },
    reconciliationStatusTagType: function reconciliationStatusTagType(status) {
      var map = {
        0: 'info',
        1: 'success'
      };
      return map[status] || 'info';
    },
    statusText: function statusText(status) {
      var map = {
        0: '已生成',
        1: '生成中',
        2: '生成失败'
      };
      return map[status] || '-';
    },
    statusTagType: function statusTagType(status) {
      var map = {
        0: 'info',
        1: 'warning',
        2: 'danger'
      };
      return map[status] || 'info';
    },
    paymentStatusText: function paymentStatusText(status) {
      var map = {
        0: '未打款',
        1: '部分打款',
        2: '已打款'
      };
      return map[status] || '-';
    },
    paymentStatusTagType: function paymentStatusTagType(status) {
      var map = {
        0: 'info',
        1: 'warning',
        2: 'success'
      };
      return map[status] || 'info';
    },
    cycleTypeText: function cycleTypeText(type) {
      var map = {
        day: '日结',
        week: '周结',
        half_month: '半月结',
        month: '月结'
      };
      return map[type] || type || '-';
    },
    merchantTypeText: function merchantTypeText(type) {
      var map = {
        1: '卡券供应商',
        2: '实物供应商',
        3: '家政供应商',
        4: '核销供应商'
      };
      return map[type] || '-';
    },
    merchantTypeTagType: function merchantTypeTagType(type) {
      var map = {
        1: 'primary',
        2: 'warning',
        3: 'success',
        4: 'info'
      };
      return map[type] || 'info';
    },
    getFileName: function getFileName(url) {
      if (!url) return '';
      var fileName = String(url).split('/').pop() || '';
      return decodeURIComponent(fileName.split('?')[0]);
    },
    parseMerchantFiles: function parseMerchantFiles(merchantFile) {
      var _this2 = this;
      if (!merchantFile) return [];
      if (Array.isArray(merchantFile)) {
        return merchantFile.filter(Boolean).map(function (url) {
          return {
            name: _this2.getFileName(url),
            url: url
          };
        });
      }
      return String(merchantFile).split(',').map(function (url) {
        return url.trim();
      }).filter(Boolean).map(function (url) {
        return {
          name: _this2.getFileName(url),
          url: url
        };
      });
    }
  }
};